export default "assets/images/map_mobile_france-565aaf4e.jpg";